import React from 'react';
import { regularInputClass } from '../../styles/styles';
import '../../css/dropDownSearch.css';
import { useEffect } from "react";

//USAGE
//data must be: {value: "x", name: "X"}
/*
<DynamicSelectWithSearch key={'ds' + i}
                    id={'ds' + i}
                    data={this.state.nostroAccounts}
                    placeholder='Select an Account...'
                    className={this.formatValidSelect(x.nostroValid !== undefined ? x.nostroValid : true)}
                    getValue={(obj) => {
                        if (obj && obj.value !== undefined) {
                            x.NostroAccount = obj.value
                        }
                    }}
                    objValue={{ value: x.NostroAccount }}
                />
*/


export default class DynamicSelectWithSearch extends React.Component {
    state = {
        value: 'select',
        data: [],
        filteredData: [],
        searchText: '',
        selectedText: '',
        open: false,
        controlWidth: 0,
        placeholder: '',
        hasFocus: false,
        highlightedIndex: -1
    }

    ref = React.createRef();

    componentDidMount() {
        const { current } = this.ref;
        this.setState({ controlWidth: current.offsetWidth });

        document.addEventListener("mousedown", this.handleClickOutside);

        const propData = this.props.data || [];
        this.setState({ data: propData, filteredData: propData });

        let propValue = 'select';
        let propText = '';

        if (this.props.objValue && this.props.objValue.value !== '') {
            const item = propData.find(d => d.value === this.props.objValue.value);
            if (item) propText = item.name;
            propValue = this.props.objValue.value;
        }

        this.setState({ value: propValue, selectedText: propText }, () => {
            this.props.getValue(this.state.value);
        });

        this.setState({ placeholder: this.props.placeholder || '' });

        if(this.props.autoFocus)// && event.keyCode === 13))
            {
            this.setState({
                open: true, hasFocus: true
            });
        }
    }

    componentDidUpdate(prevProps) {

        if(prevProps.data !== this.props.data && this.props.data){
            const propData = this.props.data || [];
            this.setState({ data: propData, filteredData: propData });
        }
        if (prevProps.data !== this.props.data || (prevProps.objValue && this.props.objValue && prevProps.objValue.value !== this.props.objValue.value && this.props.objValue.value !== '')) {
            const propData = this.props.data || [];
            const item = propData.find(d => d.value === this.props.objValue.value);
            let propValue = 'select';
            let propText = '';
            if (item) propText = item.name;
            propValue = this.props.objValue.value;
            this.setState({ value: propValue, selectedText: propText }, () => {
            this.props.getValue(this.state.value);
        });
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.ref.current && !this.ref.current.contains(event.target)) {
            this.setState({ open: false, highlightedIndex: -1 });
        }
    }

    onSelect = (selectedItem) => {
        this.props.getValue(selectedItem);
        this.setState({
            value: selectedItem.value,
            selectedText: selectedItem.name,
            open: false,
            highlightedIndex: -1
        });
    }

    handleUpdateSearch = (event) => {
        const searchText = event.target.value.toLowerCase();
        const filteredData = this.state.data.filter(d =>
            d.name.toLowerCase().includes(searchText)
        );

        this.setState({
            searchText,
            filteredData,
            highlightedIndex: filteredData.length ? 0 : -1
        });
    }

    onClickSearchControl = () => {
        this.setState(prev => ({
            open: !prev.open,
            highlightedIndex: -1,
            hasFocus: true
        }));
    }

    handleKeyDown = (event) => {
        const { open, filteredData, highlightedIndex } = this.state;

        if (!open) return;

        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.setState({
                    highlightedIndex:
                        highlightedIndex < filteredData.length - 1
                            ? highlightedIndex + 1
                            : 0
                });
                break;

            case 'ArrowUp':
                event.preventDefault();
                this.setState({
                    highlightedIndex:
                        highlightedIndex > 0
                            ? highlightedIndex - 1
                            : filteredData.length - 1
                });
                break;

            case 'Enter':
                event.preventDefault();
                if (highlightedIndex >= 0) {
                    this.onSelect(filteredData[highlightedIndex]);
                }
                break;

            case 'Escape':
                this.setState({ open: false, highlightedIndex: -1 });
                break;

            default:
                break;
        }
    }

       onKeyPress = (event) => {
        if (event.target.id.includes('dropdownInput')) {
            if(event.keyCode === 9 || (this.props.autoFocus))// && event.keyCode === 13))
            {
            this.setState({
                open: true, hasFocus: true
            });
        }
        }
    }

    render() {
        const disabled = !!this.props.disabled;
        const options = [];

        for (let i = 0; i < this.state.filteredData.length; i++) {
            const item = this.state.filteredData[i];
            const isHighlighted = i === this.state.highlightedIndex;

            options.push(
                <div
                    key={item.value}
                    className={
                        'optionDropdownSearch' +
                        (isHighlighted ? ' highlighted' : '') +
                        (this.state.value === item.value ? ' optionDropdownSearchSelected' : '')
                    }
                    onClick={() => this.onSelect(item)}
                >
                    {item.name}
                </div>
            );
        }

        return (
            <div
                id={this.props.id}
                className="dropdownSearch"
                ref={this.ref}
                onKeyUp={this.onKeyPress}
            >
                <input
                    id={'dropdownInput-' + this.props.id}
                    type="text"
                    className={regularInputClass + ' ' + this.props.className}
                    readOnly
                    placeholder={this.state.placeholder}
                    value={this.state.selectedText}
                    onClick={this.onClickSearchControl}
                    onKeyDown={this.handleKeyDown}
                    autoFocus={this.props.autoFocus}
                />

                {this.state.open &&
                    <div
                        className="optionsContainer"
                        style={{ width: this.state.controlWidth }}
                    >
                        <input
                            type="text"
                            className={regularInputClass}
                            autoFocus
                            placeholder="Enter search text"
                            value={this.state.searchText}
                            onChange={this.handleUpdateSearch}
                            onKeyDown={this.handleKeyDown}
                        />
                        {options}
                    </div>
                }
            </div>
        );
    }
}